import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import styles from './styles.module.scss';

/**
 * @link https://jpuri.github.io/react-draft-wysiwyg/#/
 */
import { EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';

export type TextEditorProps = {
    editorState: EditorState;
    setEditorState: React.Dispatch<React.SetStateAction<EditorState>>;
};

export const TextEditor = ({ editorState, setEditorState }: TextEditorProps) => {
    const onEditorStateChange = (newEditorState: EditorState) => {
        setEditorState(newEditorState);
    };

    return (
        <Editor
            editorState={editorState}
            wrapperClassName={styles.wrapper}
            editorClassName={styles.editor}
            onEditorStateChange={onEditorStateChange}
            toolbar={{
                options: ['inline', 'list', 'textAlign', 'history'],
                inline: {
                    inDropdown: false,
                    className: undefined,
                    component: undefined,
                    dropdownClassName: undefined,
                    options: [
                        'bold',
                        'italic',
                        'underline',
                        'strikethrough',
                        'monospace',
                        'superscript',
                        'subscript'
                    ]
                },
                list: {
                    options: ['unordered', 'ordered']
                },
                textAlign: {
                    options: ['left', 'center', 'right', 'justify']
                },
                history: {
                    inDropdown: false,
                    options: ['undo', 'redo']
                }
            }}
        />
    );
};
